import { Link } from "preact-router";
import styles from "./styles.scss";
import { useState } from "preact/hooks";

const Text = ({ children }) => children;

export default function Header() {
  const [isOpenMenu, setIsOpenMenu] = useState(false);

  const handleOpenMenu = () => {
    setIsOpenMenu(true);
  };

  const handleCloseMenu = () => {
    setIsOpenMenu(false);
  };

  return (
    <header id="header" className={styles.header}>
      <div className={styles.container}>
        <Link className={styles.logo} href="/" class={styles.logo}>
          <picture>
            <source
              media="(max-width: 564px)"
              srcSet="/assets/logo/logo-small-dark.svg"
            />
            <source
              media="(min-width: 565px)"
              srcSet="/assets/logo/logo-full-dark.svg"
            />
            <img
              src="/assets/logo/logo-full-dark.svg"
              alt="Логотип компании ИТК"
            />
          </picture>
        </Link>
        <nav className={styles.nav}>
          <div className={styles.navList}>
            <Link href="/info" className={styles.navItem}>
              <Text id="header.about_company">
                Сведения об образовательной организации
              </Text>
            </Link>
          </div>
          <div className={styles.navItemWrapper}>
            <a id="specialButton" href="#" className={styles.navItem}>
              Версия для слабовидящих
            </a>
            <span className={styles.divider} />
            <button onClick={handleOpenMenu} className={styles.burgerButton}>
              <svg
                width="64"
                height="31"
                viewBox="0 0 64 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_41_18761)">
                  <path
                    d="M18.6667 20.3337C17.5622 20.3337 16.6667 21.2291 16.6667 22.3337C16.6667 23.4382 17.5622 24.3337 18.6667 24.3337V20.3337ZM53.3334 24.3337C54.438 24.3337 55.3334 23.4382 55.3334 22.3337C55.3334 21.2291 54.438 20.3337 53.3334 20.3337V24.3337ZM10.6667 7.00032C9.56218 7.00032 8.66675 7.89575 8.66675 9.00032C8.66675 10.1049 9.56218 11.0003 10.6667 11.0003V7.00032ZM53.3334 11.0003C54.438 11.0003 55.3334 10.1049 55.3334 9.00032C55.3334 7.89575 54.438 7.00032 53.3334 7.00032V11.0003ZM29.3334 -6.33301C28.2288 -6.33301 27.3334 -5.43758 27.3334 -4.33301C27.3334 -3.22844 28.2288 -2.33301 29.3334 -2.33301V-6.33301ZM53.3334 -2.33301C54.438 -2.33301 55.3334 -3.22844 55.3334 -4.33301C55.3334 -5.43758 54.438 -6.33301 53.3334 -6.33301V-2.33301ZM18.6667 24.3337H53.3334V20.3337H18.6667V24.3337ZM10.6667 11.0003H53.3334V7.00032H10.6667V11.0003ZM29.3334 -2.33301H53.3334V-6.33301H29.3334V-2.33301Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_41_18761">
                    <rect width="64" height="31" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>
        </nav>
      </div>
      <div
        className={`${styles.burgerMenu} ${isOpenMenu ? styles.active : ""}`}
      >
        <div className={styles.burgerMenuContent}>
          <button onClick={handleCloseMenu} className={styles.burgerClose}>
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M32.5506 9.21723C33.0388 8.72907 33.0388 7.93762 32.5506 7.44946C32.0625 6.9613 31.271 6.9613 30.7828 7.44946L32.5506 9.21723ZM7.44949 30.7828C6.96134 31.271 6.96134 32.0624 7.44949 32.5506C7.93765 33.0387 8.7291 33.0387 9.21726 32.5506L7.44949 30.7828ZM9.21731 7.44946C8.72915 6.9613 7.93769 6.9613 7.44954 7.44946C6.96138 7.93762 6.96138 8.72907 7.44954 9.21723L9.21731 7.44946ZM30.7829 32.5506C31.271 33.0387 32.0625 33.0387 32.5507 32.5506C33.0388 32.0624 33.0388 31.271 32.5507 30.7828L30.7829 32.5506ZM30.7828 7.44946L7.44949 30.7828L9.21726 32.5506L32.5506 9.21723L30.7828 7.44946ZM7.44954 9.21723L30.7829 32.5506L32.5507 30.7828L9.21731 7.44946L7.44954 9.21723Z"
                fill="currentColor"
              />
            </svg>
          </button>
          <nav className={styles.burgerNav}>
            <Link
              href="/info"
              class={styles.burgerNavItem}
              onClick={handleCloseMenu}
            >
              <Text id="header.about_company">
                Сведения об образовательной организации
              </Text>
            </Link>
            <a
              id="specialButton"
              href="#"
              onClick={() => {
                // eslint-disable-next-line no-undef
                $("#specialButton").click();
                handleCloseMenu();
              }}
              className={styles.burgerNavItem}
            >
              Версия для слабовидящих
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}
